import { MockPaymentAccount } from './MockPaymentAccount';
export class PaymentAccountService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
        this.MockPaymentAccount = new MockPaymentAccount();
    }
    /**
     * Set a new payment account for application with shortName parameter
     * @param shortName
     * @param paymentAccount
     */
    async set(shortName, paymentAccount) {
        return await new Promise((resolve) => {
            setTimeout(() => {
                const application = this.MockPaymentAccount.get(shortName);
                this.MockPaymentAccount.set(shortName, { ...application, paymentAccount: paymentAccount });
                // @ts-ignore
                resolve();
            }, 1000);
        });
    }
    /**
     * Delete the current payment account for application with shortName parameter
     * @param shortName
     */
    async delete(shortName) {
        return await new Promise((resolve) => {
            setTimeout(() => {
                const application = this.MockPaymentAccount.get(shortName);
                this.MockPaymentAccount.set(shortName, { ...application, paymentAccount: undefined });
                // @ts-ignore
                resolve();
            }, 1000);
        });
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
PaymentAccountService.$inject = ['MessagingHubService'];
